import { useEffect, useMemo } from "react";
import { useLocation, useNavigate, useOutletContext, useParams } from "react-router-dom";
import { EntryEditor } from "@/components/EntryEditor";

const isToday = (iso) => new Date(iso).toDateString() === new Date().toDateString();
export const newEntryPath = () => {
  const id = crypto.randomUUID();
  return [`/escribir/${id}`, { state: { nueva: id } }];
};

export default function Escribir() {
  const { entryId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const { entries, loaded, upsertEntry, removeEntry, patchEntry } = useOutletContext();
  const found = entries.find((e) => e.id === entryId);
  const isBlank = !!entryId && !found && location.state?.nueva === entryId;
  const presetTitle = location.state?.title || "";
  const blank = useMemo(() => ({ id: entryId, title: presetTitle, body: "", moods: [], writing_ms: 0, created_at: new Date().toISOString() }), [entryId]);

  useEffect(() => {
    if (!loaded || found || isBlank) return;
    if (!entryId) {
      const today = entries.find((e) => isToday(e.created_at));
      if (today) navigate(`/escribir/${today.id}`, { replace: true });
      else { const [path, opts] = newEntryPath(); navigate(path, { ...opts, replace: true }); }
    } else {
      navigate("/escribir", { replace: true });
    }
  }, [loaded, found, isBlank, entryId, entries, navigate]);

  if (!loaded || (!found && !isBlank)) return <p className="text-sm text-meta p-6" data-testid="entry-loading">Abriendo tu hoja…</p>;

  const onDeleted = (id) => {
    removeEntry(id);
    const [path, opts] = newEntryPath();
    navigate(path, { ...opts, replace: true });
  };

  return <EntryEditor key={entryId} initial={found || blank} saved={!!found} onSaved={upsertEntry} onDeleted={onDeleted}
    onCompanion={(id, companion) => patchEntry(id, { companion })} />;
}
